module.exports = __webpack_public_path__ + "img/17331199.c55117dc.png";